import { render, staticRenderFns } from "./psuBmUploadFileForm.vue?vue&type=template&id=249773f1&scoped=true&"
import script from "./psuBmUploadFileForm.vue?vue&type=script&lang=js&"
export * from "./psuBmUploadFileForm.vue?vue&type=script&lang=js&"
import style0 from "./psuBmUploadFileForm.vue?vue&type=style&index=0&id=249773f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249773f1",
  null
  
)

export default component.exports